/* src/app/shared/components/dropdown/dropdown.component.scss */
app-dropdown {
  display: inline-block;
}
.btn-padding {
  width: 36px !important;
  padding: 0 !important;
}
.avatar-image {
  width: 35px;
  height: 33px;
  border-radius: 4px;
}
/*# sourceMappingURL=dropdown.component.css.map */
